var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xB2\xB4\xED\x81\xAC \xEB\xB0\x95\xEC\x8A\xA4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624569",
    width: 32,
    height: 32,
    rx: 10.6667,
    fill: "#00C13A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xB2\xB4\xED\x81\xAC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xB2\xB4\xED\x81\xAC_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xED\x8C\xA8\xEC\x8A\xA4 13428",
    d: "M8.88867 16.8882L14.222 21.3327L23.1109 10.666",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCheck);
export default __webpack_public_path__ + "static/media/ActiveCheck.86ae323c3059c6e5d89bffa22ac2780b.svg";
export { ForwardRef as ReactComponent };